import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const DiagramArrowLeftShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M213 2.1c-9.7 2.5-20 7.4-27.5 13.2-3.3 2.5-42.7 41.4-87.6 86.4-86.2 86.4-85.8 86-91.5 100.9-6.9 18.2-6.9 36.9-.1 55.6 8.4 23.2 28.9 41.1 54.7 47.9 3 .8 20.4 1.4 52.3 1.8l47.9.6 3.3 3.6c2.7 3 3.5 4.9 4.4 11 25.6 161.6 80.5 306.9 166.8 441.5 123.5 192.9 304.5 344.2 517.7 433.1 85.8 35.7 179.4 61.5 271.6 74.7 30.8 4.5 52.1 6.7 69.5 7.3 15.2.5 17.9.3 25.5-1.6 27.5-6.9 48.3-27.2 56.2-54.8 1.7-6.1 2.2-10.4 2.2-19.8 0-14.8-1.8-22.7-8.1-35.5-4-8.1-6.1-10.9-14.2-19-15.6-15.6-28.1-20.9-55.4-23.5-49.8-4.8-95.2-12.2-138.5-22.5-156.3-37.1-298.6-110.6-420-216.8-33.3-29.2-75.6-72.6-104.9-107.7-38.2-45.8-74-97.9-103.7-151-10.3-18.3-35.6-69.9-43.9-89.5-27.9-65.8-49-134.7-61.8-202-2.9-15.6-3-16.8-1.6-20.3.9-2 3-4.5 4.9-5.7 3.1-1.9 5-2 30.3-2 30.8-.1 38.3-.8 50.1-4.9 12.1-4.1 18.7-8.4 29.1-18.7 8-8 9.7-10.3 14.1-19.5 6.8-14 8.6-22.7 8-38.3-.8-18-5.6-31.1-16.9-45.1C437.4 170.8 283 17.6 276.2 13.1c-8-5.4-15.6-8.8-25.1-11.2-10.2-2.6-27.8-2.5-38.1.2z"
    })
  });
};

export { DiagramArrowLeftShape };
//# sourceMappingURL=DiagramArrowLeftShape.js.map
